import { lazyNamed } from 'src/utils/lazyNamed';

const CompanyDetails = {
  Layout: lazyNamed(() => import('./components/Layout'), 'Layout'),
  AccountsList: lazyNamed(() => import('./containers/AccountsList'), 'AccountsList'),
  EmailSyncExclusionsList: lazyNamed(() => import('./containers/EmailSyncExclusionsList'), 'EmailSyncExclusionsList'),
  PermissionsList: lazyNamed(() => import('./containers/PermissionsList'), 'PermissionsList'),
  ProgrammaticSeatsList: lazyNamed(() => import('./containers/ProgrammaticSeatsList'), 'ProgrammaticSeatsList'),
  WebsitesList: lazyNamed(() => import('./containers/WebsitesList'), 'WebsitesList'),
  UserRolesList: lazyNamed(() => import('./containers/UserRolesList'), 'UserRolesList'),
};

export default CompanyDetails;
